angular.module('app.shared.dateService', [])
  .factory('app.shared.dateService', [
    'CURRENT_SEASON',
    function (CURRENT_SEASON) {
      "use strict";

      let service = {

        seasonList: [],
        seasonObject: {},

        startseasonId: 1,
        startseasonYear: '1799/1800',

        generateSeasonList: function (start_season, start_season_year, end_season) {
            if(service.seasonList.length) {
              service.seasonList = [];
            }

            if (!end_season || _.isUndefined(end_season)) {
              end_season = CURRENT_SEASON;
            }

            service.startseasonId = start_season;
            service.startseasonYear = start_season_year;

            for (let i = start_season; i <= end_season; i++) {
              service.seasonObject.id = i;
              service.seasonObject.year = service.calculateSeasonYear(i, start_season);
              service.seasonList.push(service.seasonObject);

              service.seasonObject = {};
            }

          return service.seasonList;
        },

        getSeasonId: function (date) {
          service.startseasonYear.split(service.startseasonYear.substr(4, 1));

          let seasonId = null;

          let format = 'MM/DD/YYYY';

          date = moment(date, format);

          if (moment.isMoment(date)) {
            let currentYear = date.toDate().getFullYear();
            let startSeasonDate = moment(('09/01/' + currentYear), format);
            let diff = Number(currentYear) - Number(service.startseasonYear[0]);

            if (Number(currentYear) < Number(service.startseasonYear[0])) {
              return service.startseasonId;
            } else {
              seasonId = date.isBefore(startSeasonDate) ? service.startseasonId + diff
                : (service.startseasonId + diff) + 1;
              return seasonId;
            }
          }
        },

        calculateSeasonYear: function (season_index) {
          let split_char = service.startseasonYear.substr(4, 1);
          let array = service.startseasonYear.split(service.startseasonYear.substr(4, 1));

          let diff = (season_index - service.startseasonId) + 1;

          let start = moment(array[0]);

          if (moment.isMoment(start)) {
            start.add(diff, 'years');
          }

          let end = moment(array[1]);

          if (moment.isMoment(end)) {
            end.add(diff, 'years');
          }

          return start.format('Y') + split_char + end.format('Y');
        },

        clearList: () => {
          service.seasonList = [];
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/dateService.js